var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ColorConfiguration } from 'packages/job_lists/ColorConfiguration';
import { Entity, Type } from '@decahedron/entity';
import { MediaAsset } from 'packages/media/MediaAsset';
var AppearanceSettings = /** @class */ (function (_super) {
    __extends(AppearanceSettings, _super);
    function AppearanceSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.colors = new ColorConfiguration();
        _this.logo = null;
        _this.heroImage = null;
        _this.favicon = null;
        _this.color = null;
        _this.css = null;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AppearanceSettings.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (this.color && !this.colors.linksAndButtons) {
            this.colors.linksAndButtons = this.color;
        }
        if (this.color && !this.colors.logoBackground) {
            this.colors.logoBackground = this.color;
        }
        if (this.color && !this.colors.footerBackground) {
            this.colors.footerBackground = this.color;
        }
    };
    AppearanceSettings.prototype.toSaveRequest = function () {
        var requestJson = this.toJson();
        if (requestJson.logo) {
            requestJson.logo_id = requestJson.logo.id;
        }
        if (requestJson.hero_image) {
            requestJson.hero_image_id = requestJson.hero_image.id;
        }
        delete requestJson.hero_image;
        delete requestJson.logo;
        return requestJson;
    };
    var _a, _b, _c, _d;
    __decorate([
        Type(ColorConfiguration),
        __metadata("design:type", typeof (_a = typeof ColorConfiguration !== "undefined" && ColorConfiguration) === "function" ? _a : Object)
    ], AppearanceSettings.prototype, "colors", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_b = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _b : Object)
    ], AppearanceSettings.prototype, "logo", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_c = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _c : Object)
    ], AppearanceSettings.prototype, "heroImage", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_d = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _d : Object)
    ], AppearanceSettings.prototype, "favicon", void 0);
    return AppearanceSettings;
}(Entity));
export { AppearanceSettings };
